import { letterSpacings } from '../../bokeh/tokens/font.js';
import radii from '../../bokeh/tokens/radii.js';
import { grayscale, slate, yellow, blue } from './colors.js';

const { none: _none, ...bokehRadii } = radii;
const bokehColorGroups = {
  blackAlpha: grayscale,
  darkBlueAlpha: slate,
  gray: grayscale,
  grayAlpha: grayscale,
  lightBlueAlpha: slate,
  orange: yellow,
  vimeoBlue: blue,
  whiteAlpha: grayscale
};
const bokehTokens = {
  fontSizes: {
    "heading-4xl": "header-2xl",
    "heading-3xl": "header-2xl",
    "heading-2xl": "header-2xl",
    "heading-xl": "header-2xl",
    "heading-lg": "header-xl",
    "heading-md": "header-lg",
    "heading-sm": "header-xs",
    "heading-xs": "header-2xs",
    "heading-2xs": "header-2xs",
    "body-xl": "text-lg",
    "body-lg": "text",
    "body-md": "text-sm",
    "body-sm": "text-xs",
    "body-xs": "text-xs"
  },
  // There are no letter spacings that are explicitly defined in the Iris theme, so we are using the Bokeh letter spacings here
  colors: {
    background: "background-primary",
    "background-blur": "background-secondary",
    "status-caution-primary": "status-warning",
    "status-caution-secondary": "status-warning",
    "status-destructive-primary": "status-negative",
    "status-destructive-secondary": "status-negative",
    "status-positive-primary": "status-positive",
    "status-positive-secondary": "status-positive",
    //no exact replacement in iris
    "status-info-primary": "status-positive",
    "status-info-secondary": "status-positive",
    "check-radio-stroke": "input-border",
    "check-radio-stroke-hover": "input-border-hover",
    "check-radio-fill": "",
    //todo
    "fill-component": "fill-primary",
    "fill-component-secondary": "fill-primary",
    "fill-surface": "background",
    "fill-blur": "background",
    "fill-brand": "fill-primary",
    "fill-component-hover": "fill-primary",
    "fill-page-overlay": "",
    "fill-skeleton": "background-primary",
    "input-fill": "",
    "input-stroke": "input-border",
    "input-stroke-hover": "input-border-hover",
    "text-tertiary": "text-secondary",
    "text-button-inverted": "text-secondary"
  },
  letterSpacings,
  lineHeights: {
    "heading-4xl": "header-2xl",
    "heading-3xl": "header-2xl",
    "heading-2xl": "header-xl",
    "heading-xl": "header-lg",
    "heading-lg": "header",
    "heading-md": "header-sm",
    "heading-sm": "header-xs",
    "heading-xs": "header-2xs",
    "heading-2xs": "header-2xs",
    "body-md": "text",
    "body-xl": "text-xl",
    "body-lg": "text-lg",
    "body-sm": "text-sm",
    "body-xs": "text-xs"
  },
  radii: bokehRadii,
  space: {
    xs: "0.25rem",
    // 4px
    sm: "0.5rem",
    // 8px
    md: "1rem",
    // 16px
    lg: "1.5rem",
    // 24px
    xl: "2rem",
    // 32px
    "2xl": "2.5rem",
    // 40px
    "3xl": "3rem"
    // 48px
    //removing these tokens for the moment as they can cause problems with the px that is added by styled system
    //for example 20 would be 20 pixels before this change but 80px after
    //   px: '.0625rem', // 1px
    //   1: '50', // 4px
    //   2: '75', // 8px
    //   3: '100', // 12px
    //   4: '200', // 16px
    //   5: '1.25rem', // 20px
    //   6: '300', // 24px
    //   7: '1.75rem', // 28px
    //   8: '400', // 32px
    //   9: '2.25rem', // 36px
    //   10: '500', // 40px
    //   12: '600', // 48px
    //   14: '3.5rem', // 56px
    //   16: '800', // 64px
    //   20: '5rem', // 80px
    //   24: '1200', // 96px
    //   28: '7rem', // 112px
    //   32: '8rem', // 128px
    //   36: '9rem', // 114px
    //   40: '10rem', // 160px
    //   44: '11rem', // 176px
    //   48: '12rem', // 192px
    //   52: '13rem', // 208px
    //   56: '14rem', // 224px
    //   60: '15rem', // 240px
    //   64: '16rem', // 256px
    //   72: '18rem', // 288px
    //   80: '20rem', // 320px
    //   96: '24rem', // 384px
  },
  shadows: {
    sm: "shadow-sm",
    md: "shadow-md"
  }
};

export { bokehColorGroups, bokehTokens };
